import Menu from './Menu'
import Copyright from './Copyright'
import SocialMedia from './SocialMedia'
import LogoFooter from './Logo'
import { Wrapper, Container, List } from './style'

const FooterComponent = ({ ...others }) => (
  <Wrapper {...others}>
    <Container maxWidth="lg">
      <List>
        <LogoFooter />
        <Menu />
        <SocialMedia />
      </List>
    </Container>
    <Copyright />
  </Wrapper>
)

export default FooterComponent
